export const config = {
  BaseURL: import.meta.env.NX_API_URL,
  ClientId: import.meta.env.NX_COGNITO_CLIENT_ID,
  /**
   * The viewer's lib is copied into /assets of this very build, so its base URL
   * is always the origin serving the app. Naming a host instead pins every
   * deploy to that one origin, and the CSP's `script-src 'self'` then blocks
   * the viewer everywhere else - Netlify gives each pull request its own
   * subdomain. The SDK rejects a relative URL, so build an absolute one.
   */
  PDFKitBaseUrl: `${window.location.origin}/assets/`,
  PDFKitServerUrl: import.meta.env.NX_PSPDFKIT_SERVER_URL,
  UserPoolId: import.meta.env.NX_COGNITO_USER_POOL_ID,
  sentry: {
    dsn: import.meta.env.NX_SENTRY_DSN,
    debug: import.meta.env.NX_DEBUG === 'true',
    environment: import.meta.env.NX_ENVIRONMENT,
    release: import.meta.env.GIT_COMMIT_SHA,
  },
  N26CustomerId: import.meta.env.NX_N26_CUSTOMER_ID,
}
